import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

// Benign browser notification; CRA's error overlay treats it as a fatal runtime error.
// Defer RO callbacks so nested layout writes (modals, video, sticky rails) don't loop.
const isResizeObserverNoise = message =>
  typeof message === "string" && message.includes("ResizeObserver loop");

if (typeof window !== "undefined" && window.ResizeObserver) {
  const NativeRO = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends NativeRO {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}

const suppressResizeObserverEvent = event => {
  const message =
    (event && event.message) ||
    (event && event.error && event.error.message) ||
    "";
  if (!isResizeObserverNoise(message)) return;
  event.stopImmediatePropagation();
  if (typeof event.preventDefault === "function") event.preventDefault();
};

window.addEventListener("error", suppressResizeObserverEvent, true);
window.addEventListener(
  "unhandledrejection",
  event => {
    const reason = event.reason;
    const message =
      typeof reason === "string"
        ? reason
        : reason && reason.message
        ? reason.message
        : "";
    if (isResizeObserverNoise(message)) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  },
  true
);

// Extra guard for CRA / webpack-dev-server overlay hooks
const originalOnError = window.onerror;
window.onerror = function (message, ...rest) {
  if (isResizeObserverNoise(String(message))) return true;
  if (typeof originalOnError === "function") {
    return originalOnError.call(this, message, ...rest);
  }
  return false;
};

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
